import React from "react";
import PropTypes from "prop-types";
import "./Sidebar.css";
import { TbX, TbChevronDown } from "react-icons/tb";
import { Link } from "react-router-dom";
import projectsData from "../../Projects/projectsData";

// Home is reached via the logo; "Projects" expands on tap to list projects.
const LINKS = [
  { to: "/about", label: "About" },
  {
    label: "Projects",
    // No hover on touch, and the group header is a toggle — so the index page
    // needs its own entry to be reachable at all.
    children: [
      { to: "/projects", label: "Projects Overview" },
      ...projectsData.map((p) => ({ to: `/projects/${p.slug}`, label: p.title })),
    ],
  },
  { to: "/sponsors", label: "Sponsors" },
  { to: "/ourteam", label: "Our Team" },
  { to: "/join-us", label: "Join Us" },
];

// Full-screen mobile navigation overlay.
export default function Sidebar({ open, onClose }) {
  const closeButtonRef = React.useRef(null);
  const [projectsOpen, setProjectsOpen] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      // collapse the projects list whenever the menu closes
      setProjectsOpen(false);
      return undefined;
    }
    closeButtonRef.current?.focus();
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  return (
    <div
      className={open ? "SidebarContainer SidebarOpen" : "SidebarContainer"}
      role="dialog"
      aria-modal="true"
      aria-label="Navigation menu"
      aria-hidden={!open}
    >
      <button
        type="button"
        ref={closeButtonRef}
        className="SidebarClose"
        aria-label="Close navigation menu"
        onClick={onClose}
      >
        <TbX aria-hidden="true" />
      </button>
      <nav className="SidebarMenu" aria-label="Mobile navigation">
        {LINKS.map((item) =>
          item.children ? (
            <div key={item.label} className="SidebarGroup">
              <button
                type="button"
                className="SidebarLink SidebarGroupToggle"
                aria-expanded={projectsOpen}
                onClick={() => setProjectsOpen((prev) => !prev)}
              >
                {item.label}
                <TbChevronDown
                  className={projectsOpen ? "SidebarChevron SidebarChevronOpen" : "SidebarChevron"}
                  aria-hidden="true"
                />
              </button>
              {projectsOpen &&
                item.children.map((child) => (
                  <Link
                    key={child.to}
                    className="SidebarLink SidebarSubLink"
                    to={child.to}
                    onClick={onClose}
                  >
                    {child.label}
                  </Link>
                ))}
            </div>
          ) : (
            <Link key={item.to} className="SidebarLink" to={item.to} onClick={onClose}>
              {item.label}
            </Link>
          )
        )}
      </nav>
    </div>
  );
}

Sidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
